module.exports = __webpack_public_path__ + "assets/img/Black.018fc7ad.svg";